import axios from "axios";

export const GET_TIPOS_CONTRATISTA = "GET_TIPOS_CONTRATISTA";
export const POST_IDENTIFICACION_FORM = "POST_IDENTIFICACION_FORM";
export const POST_UBICACION_FORM = "POST_UBICACION_FORM";
export const POST_DEMOLICION = "POST_DEMOLICION";
export const POST_TIPO_DE_OBRA = "POST_TIPO_DE_OBRA";
export const POST_ACTIVIDAD = "POST_ACTIVIDAD";

export const GET_PREGUNTAS_TIPO_DE_OBRA = "GET_PREGUNTAS_TIPO_DE_OBRA";
export const GET_PREGUNTAS_ACTIVIDAD = "GET_PREGUNTAS_ACTIVIDAD";

export const DELETE_LOCAL_RESPONSABLE = "OBRA_DELETE_LOCAL_RESPONSABLE";
export const ADD_LOCAL_RESPONSABLE = "OBRA_ADD_LOCAL_RESPONSABLE";
export const POST_CARGA_NUEVA_OBRA = "POST_CARGA_NUEVA_OBRA";
export const CLEAR_NUEVA_OBRA = "CLEAR_NUEVA_OBRA";
export const VALIDAR_CARGA_NUEVA_OBRA = "VALIDAR_CARGA_NUEVA_OBRA";
export const GET_ESTABLECIMIENTOS = "GET_ESTABLECIMIENTOS";
export const POST_DEPENDENCIA_EMPLEADOR = "POST_DEPENDENCIA_EMPLEADOR";
export const GET_ACTIVIDADES_EMPLEADOR = "GET_ACTIVIDADES_EMPLEADOR";
export const GET_DATOS_ESTABLECIMIENTOS = "GET_DATOS_ESTABLECIMIENTOS";
export const CLEAR_DATOS_ESTABLECIMIENTOS = "CLEAR_DATOS_ESTABLECIMIENTOS";
export const GET_GESTION_OBRAS = "GET_GESTION_OBRAS";
export const GET_ULTIMO_FORMULARIO_CARGADO = "GET_ULTIMO_FORMULARIO_CARGADO";
export const GET_VISUALIZACION_ULTIMO_FORMULARIO_CARGADO = "GET_VISUALIZACION_ULTIMO_FORMULARIO_CARGADO";
export const GET_VISUALIZACION_FORMULARIO_CARGADO = "GET_VISUALIZACION_FORMULARIO_CARGADO";
export const FINALIZAR_OBRA = "FINALIZAR_OBRA";
export const VISUALIZAR_CERTIFICADO_PRESENTACION = "VISUALIZAR_CERTIFICADO_PRESENTACION";
export const ADJUNTAR_PROGRAMA_SEGURIDAD = "ADJUNTAR_PROGRAMA_SEGURIDAD";
export const GET_TIPOS_AVISO_OBRA = "GET_TIPOS_AVISO_OBRA";
export const POST_RESPONSABLES_FORM = "POST_RESPONSABLES_FORM";
export const GET_DIAS_FECHA_INICIO_OBRA = "GET_DIAS_FECHA_INICIO_OBRA";
export const GET_FECHA_LIMITE_EXTENSION_OBRA = "GET_FECHA_LIMITE_EXTENSION_OBRA";
export const GET_HABILITAR_EDICION_OBRA = "GET_HABILITAR_EDICION_OBRA";
export const GET_PROGRAMA_SEGURIDAD = "GET_PROGRAMA_SEGURIDAD";
export const GET_HABILITADO_GUARDADO_OBRAS_CON_INTERCAMBIOS_PENDIENTES = "GET_HABILITAR_GUARDADO_OBRAS_CON_INTERCAMBIOS_PENDIENTES";

export const getTiposContratista = () => (dispatch) => {
  return dispatch({
    type: GET_TIPOS_CONTRATISTA,
    payload: axios
      .get(`avisoObra/tiposContratista`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};
export const getPreguntasTipoDeObra = () => (dispatch) => {
  return dispatch({
    type: GET_PREGUNTAS_TIPO_DE_OBRA,
    payload: axios
      .get(`avisoObra/itemsTipoObra`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const getPreguntasActividad = () => (dispatch) => {
  return dispatch({
    type: GET_PREGUNTAS_ACTIVIDAD,
    payload: axios
      .get(`avisoObra/itemsActividadObra`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const postDependenciaEmpleador = (values) => (dispatch) => {
  return dispatch({
    type: POST_DEPENDENCIA_EMPLEADOR,
    payload: axios
      .post(`dependenciaEmpleador/cargarDependenciaEmpleador`, values)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};
export const getDatosEstablecimiento = (establecimiento) => (dispatch) => {
  return dispatch({
    type: GET_DATOS_ESTABLECIMIENTOS,
    payload: axios
      .get(
        `dependenciaEmpleador/datosBasicos?idDependenciaEmpleador=${establecimiento}`
      )
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const postIdentificacionForm = (values) => (dispatch) => {
  return dispatch({
    type: POST_IDENTIFICACION_FORM,
    payload: values,
  });
};

export const postUbicacionForm = (values) => (dispatch) => {
  return dispatch({
    type: POST_UBICACION_FORM,
    payload: values,
  });
};

export const postDemolicionForm = (values) => (dispatch) => {
  return dispatch({
    type: POST_DEMOLICION,
    payload: values,
  });
};

export const postTipoDeObraForm = (values) => (dispatch) => {
  return dispatch({
    type: POST_TIPO_DE_OBRA,
    payload: values,
  });
};
export const postActividadForm = (values) => (dispatch) => {
  return dispatch({
    type: POST_ACTIVIDAD,
    payload: values,
  });
};

export const postResponsablesForm = (values) => (dispatch) => {
  return dispatch({
    type: POST_RESPONSABLES_FORM,
    payload: values,
  });
};

export const postCargaNuevaObra = (values) => (dispatch) => {
  return dispatch({
    type: POST_CARGA_NUEVA_OBRA,
    payload: axios
      .post(`avisoObra/cargarAvisoObra`, values)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const clearNuevaObra = () => (dispatch) => {
  return dispatch({
    type: CLEAR_NUEVA_OBRA,
  });
};

export const clearDatosEstablecimiento = () => (dispatch) => {
  return dispatch({
    type: CLEAR_DATOS_ESTABLECIMIENTOS,
  });
};

export const validarCargaNuevaObra = (values) => (dispatch) => {
  const { idDependenciaEmpleador, fechaInicioObra, fechaFinObra } = values;
  return dispatch({
    type: VALIDAR_CARGA_NUEVA_OBRA,
    payload: axios
      .get(
        `avisoObra/validarDisponibilidadCargaAvisoObra?idDependenciaEmpleador=${idDependenciaEmpleador}&fechaInicio=${fechaInicioObra}&fechaFinEstimada=${fechaFinObra}`
      )
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

// Pasando idGestionObra se actualiza la gestion de obra con ese id. De esa forma no necesitamos traer toda la tabla al apretar algun boton de la tabla de gestionesObra
export const getGestionObra = (idGestionObra) => (dispatch) => {
  return dispatch({
    type: GET_GESTION_OBRAS,
    payload: axios.get(`avisoObra/gestionesObra?${idGestionObra ? `idGestionObra=${idGestionObra}` : ""}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
    meta: {
      idGestionObra: idGestionObra,
    }
  })
}

export const getVisualizarUltimoFormularioCargado = (idGestionObra) => (dispatch) => {
  return dispatch({
    type: GET_VISUALIZACION_ULTIMO_FORMULARIO_CARGADO,
    payload: axios.get(`avisoObra/visualizarUltimoFormularioCargado?idGestionObra=${idGestionObra}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  })
}
export const getVisualizacionFormularioCargado = (idAvisoObra) => (dispatch) => {
  return dispatch({
    type: GET_VISUALIZACION_FORMULARIO_CARGADO,
    payload: axios.get(`avisoObra/visualizarFormularioCargado?idAvisoObra=${idAvisoObra}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  })
}

export const finalizarObra = (idGestionObra) => (dispatch) => {
  return dispatch({
    type: FINALIZAR_OBRA,
    payload: axios
      .post(`avisoObra/finalizarGestion?idGestionObra=${idGestionObra}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error))
  });
}

export const getVisualizacionCertificadoPresentacion = (idAvisoObra) => (dispatch) => {
  return dispatch({
    type: VISUALIZAR_CERTIFICADO_PRESENTACION,
    payload: axios.get(`avisoObra/visualizarCertificadoPresentacion?idAvisoObra=${idAvisoObra}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
}

export const getUltimoFormularioCargado = (idGestionObra) => (dispatch) => {
  return dispatch({
    type: GET_ULTIMO_FORMULARIO_CARGADO,
    payload: axios.get(`avisoObra/ultimoFormularioCargado?idGestionObra=${idGestionObra}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
}

export const adjuntarProgramaSeguridad = (values) => (dispatch) => {
  return dispatch({
    type: ADJUNTAR_PROGRAMA_SEGURIDAD,
    payload: axios.post(`avisoObra/adjuntarProgramaSeguridad`, values)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
}
export const getTiposAvisoObra = (idGestionObra) => (dispatch) => {
  return dispatch({
    type: GET_TIPOS_AVISO_OBRA,
    payload: axios.get(`avisoObra/tiposAvisoObra?idGestionObra=${idGestionObra}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  })
}

export const getDiasFechaInicioObra = () => (dispatch) => {
  return dispatch({
    type: GET_DIAS_FECHA_INICIO_OBRA,
    payload: axios.get(`avisoObra/diasFechaInicioObra`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  })
}

export const getHabilitarEdicionObra = () => (dispatch) => {
  return dispatch({
    type: GET_HABILITAR_EDICION_OBRA,
    payload: axios.get(`avisoObra/habilitarEdicion`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  })
}

export const getFechaLimiteExtensionObra = (idGestionObra) => (dispatch) => {
  return dispatch({
    type: GET_FECHA_LIMITE_EXTENSION_OBRA,
    payload: axios.get(`avisoObra/getFechaLimiteExtensionObra?idGestionObra=${idGestionObra}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  })
}

export const addLocalResponsable = (values) => (dispatch) => {
  return dispatch({
    type: ADD_LOCAL_RESPONSABLE,
    payload: values,
  });
};

export const deleteLocalResponsable = (values) => (dispatch) => {
  return dispatch({
    type: DELETE_LOCAL_RESPONSABLE,
    payload: values,
  });
};

export const getProgramaDeSeguridad = (idGestionObra) => (dispatch) => {
  return dispatch({
    type: GET_PROGRAMA_SEGURIDAD,
    payload: axios.get(`avisoObra/visualizarUltimoPlanSeguridadCargado?idGestionObra=${idGestionObra}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  })
}

export const getHabilitadoGuardadoObrasConIntercambiosPendientes = () => (dispatch) => {
  return dispatch({
    type: GET_HABILITADO_GUARDADO_OBRAS_CON_INTERCAMBIOS_PENDIENTES,
    payload: axios.get(`avisoObra/habilitarGuardadoObrasConIntercambiosPendientes`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  })
} 